export default __webpack_public_path__ + "static/media/Building1.6f8863a7.jpeg";